import CardSystem from '../CardSystem';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { SCORE_ROPE_CARD } from '../../../Constants/Score';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function ScissorsCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const sourceCard: BaseCard = system.getCardByID(taskData.source);
    sourceCard.score = taskData.cardsScore[0];

    const keyAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(keyAnimator);

    const targetCards: BaseCard[] = [];
    for (let i = 0; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        if (i < taskData.cardsScore.length) {
            card.score = taskData.cardsScore[i];
        }
        targetCards.push(card);
    }

    system.taskQueue.queue(
        new CardAnimationTask(taskData, system, 'CardScissors', keyAnimator, {
            system: system,
            scene: system.scene,
            sourceCard: sourceCard,
            targetCards: targetCards,
            cardScore: SCORE_ROPE_CARD,
        })
    );
}
